module.exports = __webpack_public_path__ + "static/media/0178_Medium.235ec6e8.jpg";